import cx from 'classnames'

import s from './club-select.sass'
import { IconConfirmSolid } from '../icons/confirm-solid'
import { TYPE_CHECKBOX } from './select-group'

export const TYPE_BASIC = 'basic'
export const TYPE_PREMIUM = 'premium'

export default function ClubSelect ({
  class: _class,
  className,
  type = TYPE_CHECKBOX,
  checked = false,
  name,
  clubType,
  distance,
  value,
  onChange,
  ...rest
}) {
  const combinedClassNames = cx(
    s.clubSelect,
    className,
    checked && s.isChecked
  )

  const clubTypeClassName = cx(
    s.clubInfo,
    clubType === TYPE_PREMIUM && s.isPremium
  )

  const backgroundStyle = rest.thumbnail && {
    backgroundImage: `url("${rest.thumbnail.src}")`
  }

  return (
    <label className={combinedClassNames}>
      <input type={type} checked={checked} value={value} onChange={onChange} />
      <div className={s.clubGrid}>
        <div className={s.clubImage} style={backgroundStyle} />
        <div className={s.clubText}>
          <div className={s.clubName}>{name}</div>
          {distance && <div className={s.clubDistance}>{Math.round(distance)} km bort</div>}
          <div className={clubTypeClassName}>{clubType}</div>
        </div>
        {checked && <IconConfirmSolid className={s.iconCheckmark} />}
      </div>
    </label>
  )
}



// WEBPACK FOOTER //
// ./components/signup-flow/club-select.js